import React from "react";
import LegalPageShell from "./LegalPageShell";

const ChildSafetyStandards = () => (
  <LegalPageShell>
    <h1 className="mb-6 text-center text-2xl font-bold md:text-3xl">
      Child Safety Standards
    </h1>

    <p className="mb-4 text-center italic">
      Last updated: 2 August 2026
    </p>

    <p className="mb-4">
      VaultGrid has zero tolerance for child sexual abuse and exploitation (CSAE),
      child sexual abuse material (CSAM), grooming, sextortion, trafficking, or any
      other conduct that sexualises, exploits, or endangers a child.
    </p>

    <h2 className="mb-3 mt-8 text-xl font-semibold">Who may use VaultGrid</h2>
    <p className="mb-4">
      VaultGrid is intended for adults. People under 18 are not the intended audience
      of the platform. We may restrict or remove accounts when we reasonably believe
      that a user does not meet our age requirements.
    </p>

    <h2 className="mb-3 mt-8 text-xl font-semibold">Prohibited content and conduct</h2>
    <p className="mb-2">Users must not create, upload, share, request, promote, or link to:</p>
    <ul className="mb-4 list-disc space-y-2 pl-5">
      <li>CSAM or any sexualised depiction of a child;</li>
      <li>content or conduct that grooms, coerces, blackmails, traffics, or exploits a child;</li>
      <li>attempts to arrange sexual contact with a child;</li>
      <li>content that identifies or exposes a child in a way that creates a safety risk; or</li>
      <li>material that facilitates, normalises, or encourages CSAE.</li>
    </ul>

    <h2 className="mb-3 mt-8 text-xl font-semibold">Reporting and moderation</h2>
    <p className="mb-4">
      Users can report content, profiles, messages, and other safety concerns through
      VaultGrid's in-app reporting tools. Reports are reviewed by our moderation team.
      We may remove content, restrict features, suspend or permanently ban accounts,
      preserve relevant records, and take other protective action where appropriate.
    </p>

    <h2 className="mb-3 mt-8 text-xl font-semibold">Reports to authorities</h2>
    <p className="mb-4">
      VaultGrid complies with applicable child safety laws. Where required or
      appropriate, we report suspected CSAM or child exploitation to the relevant
      regional or national authorities and cooperate with lawful investigations.
    </p>

    <h2 className="mb-3 mt-8 text-xl font-semibold">Child safety contact</h2>
    <p className="mb-4">
      To report an urgent child safety concern or contact our designated child safety
      representative, email{" "}
      <a
        href="mailto:support@vaultgrid.net"
        className="underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        support@vaultgrid.net
      </a>
      . If someone is in immediate danger, contact local emergency services first.
    </p>
  </LegalPageShell>
);

export default ChildSafetyStandards;
